import React from 'react';
import BaseTile from '../../../components/Tile/BaseTile';
import { useMissingEventObjectRefsKpi } from './hooks/useMissingEventObjectRefsKpi';
import { formatGermanNumber, formatGermanPercentage } from '../../../utils/numberFormat';

const Stat = ({ label, value }) => (
  <div className="flex flex-col items-center">
    <div className="text-xs text-gray-500">{label}</div>
    <div className="text-lg font-semibold">
      {typeof value === 'number' ? formatGermanNumber(value, { decimals: 0 }) : value}
    </div>
  </div>
);

const MissingEventObjectRef = ({ activeFile, batchData }) => {
  const { data, loading, error } = useMissingEventObjectRefsKpi(activeFile, { batchData });

  const total = data?.total_events ?? 0;
  const missing = data?.events_without_objects ?? 0;
  const ratePct = total > 0 ? (data.missing_ratio || 0) : 0;

  return (
    <BaseTile title="Events Without Objects" loading={loading} error={error} minHeight="sm" padding="default">
      <div className="h-full flex flex-col items-center justify-center gap-4">
        <div className="text-4xl font-extrabold text-orange-600">{formatGermanNumber(missing, { decimals: 0 })}</div>
        <div className="text-sm text-gray-600">events without object references</div>
        <div className="flex gap-6">
          <Stat label="Total Events" value={total} />
          <Stat label="Missing %" value={formatGermanPercentage(ratePct, 2)} />
        </div>
      </div>
    </BaseTile>
  );
};

export default MissingEventObjectRef;
